
<template>
    <!-- <div class="home" :class="{newStyle:homeChartStyle==2}" :style="tmpTheme"> -->
    <div class="home" :style="tmpTheme">
			<div v-if="showWindow">
        <template>
            <Header @getLogin="getLogin"></Header>
            <div class="main-center" :style="{height:navTwoHeight+'px'}">
                
                <div class="block" :style="{height:navTwoHeight+'px'}" :class="{blockavatar:isShowBannerAvatar=='2'}">
										<div class="custom-indicator" :style="{bottom:(isShowBannerAvatar=='2'?(Number(onavatarHeightType)+20):10)+'px'}">
											<div
												v-for="(item, index) in chars"
												:key="index"
												:class="{ active: currentIndex === index }"
												@click="changeIndicator(index)"
											></div>
										</div>
									<el-carousel indicator-position="none" arrow="always" @change="changeCarousel" ref="carouselTax">
										<el-carousel-item v-for="item in chars" :key="item.id">
												<div class="banner_item" :style="{backgroundColor: item.bgColor,height:navTwoHeight+'px'}">
													<div class="item_b" @click="jump(item)" :style="{backgroundImage: 'url('+item.img_Url+')',height:navTwoHeightIsAvatar+'px'}"></div>
												</div>
										</el-carousel-item>
									</el-carousel>

                </div>
                    
                <div class="new" :style="{height:navTwoHeight+'px'}">
                    <div id="news">
                        <div class="news_box" v-show="loginAfter" :style="{height:navTwoHeight+'px'}">
                            <div class="Member_info">
                                <p>你好，欢迎来到{{ base.webFullName }}</p>
                                <a class="ljlogin_end" href="">
                                    
                                    <img :src="userAvatar" alt="" v-if="userAvatar">
                                    <img src="../assets/img/user_avatar.png" alt="" v-else>
                                    
                                    <div class="ljlogin_endtext">
                                        <!-- <h1>{{base.webCompany}}</h1> -->
                                        <h1>{{user_name}}</h1>
                                        <p v-if="isShowPhone">{{username}}</p>
                                    </div>
                                </a>
                                <!-- <a href="">退出</a> -->
                                <a class="outloginBtn" style="cursor: pointer;" :style="tmpTheme" @click="tui()">退出</a>
                            </div>
														<div class="fool_list" :style="tmpTheme">
															<div class="fool_item" @click="goPath(item)" v-for="(item,index) in homeModelList" :key="index" v-if="item.isShow">
																<template v-if="item.code=='bz'&&isShowBzQuery">
																	<i class="iconfont">&#xe62d;</i>
																	<div class="text">{{ item.name }}</div>
																</template>
																<template v-else-if="item.code=='customized'&&openCustomized">
																	<i class="iconfont">&#xe62e;</i>
																	<div class="text">{{ item.name }}</div>
																</template>
																<template v-else>
																	<i class="iconfont" v-if="item.code=='order'">&#xe621;</i>
																	<i class="iconfont" v-if="item.code=='quick'">&#xe69b;</i>
																	<i class="iconfont" v-if="item.code=='cart'">&#xe63b;</i>
																	<i class="iconfont" v-if="item.code=='returnorder'">&#xe984;</i>
																	<i class="iconfont" v-if="item.code=='saleaccount'">&#xe638;</i>
																	<i class="iconfont" v-if="item.code=='complaint'">&#xe6d0;</i>
																	<div class="text">{{ item.name }}</div>
																</template>
															</div>
														</div>
														<div class="phtime" v-if="hotPhoneIsShow||isShowWorkTime">
															<div class="phone" v-if="hotPhoneIsShow">
																工作电话：
																<i class="iconfont">&#xe62a;</i>
																<span>{{hotPhone}}</span>
															</div>
															<div class="text" v-if="isShowWorkTime">
																工作时间：{{workTime}}
															</div>
														</div>
														<div class="exclusive feibiao"  v-if="isShowCustomizedManager&&openCustomized">
                                <div class="xia">
																	<div class="manager">
																		<div class="img" @click="showimg(customizedSeekQrCodeSrc)">
																			<img :src="customizedSeekImgSrc"/>
																		</div>
																	</div>
                                </div>
                            </div>
                            <div class="exclusive"  v-if="isShowManager"  :style="tmpTheme">
                                <div class="shang contact_list">
                                    <span class="item item1">专属客服</span>
                                    <span class="item item2">专属业务经理</span>
																		<i class="iconfont">&#xe627;</i>
                                </div>
                                <div class="xia">
                                    <div class="manager">
																				<div class="img" v-if="buyerInfo.salesImg" @click="showimg(base.imgWebUrl+buyerInfo.salesImg)"><img :src="base.imgWebUrl+buyerInfo.salesImg"/></div>
                                        <p class="name">{{buyerInfo.salesMan}}</p>
                                        <p :style="tmpTheme">{{buyerInfo.salesMobile}}</p>
                                    </div>
                                    <div class="manager">
																				<div class="img" v-if="buyerInfo.manageImg" @click="showimg(base.imgWebUrl+buyerInfo.manageImg)"><img :src="base.imgWebUrl+buyerInfo.manageImg"/></div>
                                        <p class="name">{{buyerInfo.manageMan}}</p>
                                        <p :style="tmpTheme">{{buyerInfo.manageMobile}}</p>
                                    </div>
                                </div>
                            </div>
                            
                            <!--新闻资讯/站内短信-->
                            <div class="tabbox">
                                <div class="tab">
                                    <p :class="{on:mouse == 1}" :style="{'color': varbgColor}" @mouseover="mouseover(1)" v-if="isShowNews">新闻资讯</p>
                                    <p :class="{on:mouse == 2}" :style="{'color': varbgColor}" @mouseover="mouseover(2)" v-if="isShowMessage">站内短信</p>
                                </div>
                                <div class="tabboxcontent">
                                    <ul style="width: 464px;">
                                        <li v-if="mouse == 1&&isShowNews">
                                            <span v-if="newsd&&newsd.length">
                                                <router-link :style="tmpTheme" :to="{path:'/news',query:{id:item.id}}" v-for="item in newsd" :key="item.id">{{item.title}}</router-link>
                                            </span>
                                            <div class="nothing" v-else>暂无数据</div>
                                        </li>
                                        <li v-if="mouse == 2&&isShowMessage">
                                            <span v-if="msgData&&msgData.length">
                                                <router-link :style="tmpTheme" :to="{path:'/station'}" v-for="(item,index) in msgData" :key="index">{{item.msgTitle}}</router-link>
                                            </span>
                                            <div class="nothing" v-else>暂无数据</div>
                                        </li>
                                    </ul>
                                </div>
                                <router-link v-if="mouse == 1&&isShowNews" class="tabboxmore" :to="{path:'/news'}">更多</router-link>
                                <router-link v-if="mouse == 2&&isShowMessage" class="tabboxmore" :to="{path:'/station'}">更多</router-link>
                            </div>
                        </div>
                        
                        <div class="news_box" v-show="loginBefore" :style="{height:navTwoHeight+'px'}">
                            <div class="Member_info">
                                <p>你好，欢迎来到{{ base.webFullName }}</p>
                                <ul>
                                    <li class="ljlogin" :style="{'border-color': varbgColor}">
                                        <router-link to="/login" :style="{'color': varbgColor}">立即登录</router-link>
                                    </li>
                                    <li class="ljlogin" :style="{'border-color': varbgColor}">
                                        <router-link to="/register" :style="{'color': varbgColor}">立即注册</router-link>
                                    </li>
                                </ul>
                            </div>
														<div class="fool_list" :style="tmpTheme">
															<div class="fool_item" @click="goPath(item)" v-for="(item,index) in homeModelList" :key="index" v-if="item.isShow">
																<template v-if="item.code=='bz'&&isShowBzQuery">
																	<i class="iconfont">&#xe62d;</i>
																	<div class="text">{{ item.name }}</div>
																</template>
																<template v-else-if="item.code=='customized'&&openCustomized">
																	<i class="iconfont">&#xe62e;</i>
																	<div class="text">{{ item.name }}</div>
																</template>
																<template v-else>
																	<i class="iconfont" v-if="item.code=='order'">&#xe621;</i>
																	<i class="iconfont" v-if="item.code=='quick'">&#xe69b;</i>
																	<i class="iconfont" v-if="item.code=='cart'">&#xe63b;</i>
																	<i class="iconfont" v-if="item.code=='returnorder'">&#xe984;</i>
																	<i class="iconfont" v-if="item.code=='saleaccount'">&#xe638;</i>
																	<i class="iconfont" v-if="item.code=='complaint'">&#xe6d0;</i>
																	<div class="text">{{ item.name }}</div>
																</template>
															</div>
														</div>
                            <div class="exclusive" v-if="isShowManager" :style="tmpTheme">
                                <div class="zhuan contact_list" >
                                    <span class="item item1">专属客服</span>
                                    <span class="item item2">专属业务经理</span>
																		<i class="iconfont">&#xe627;</i>
                                </div>
                                <div class="xia">
                                    <p>
                                        <router-link to="/login" :style="{'color': varbgColor}">登录后可查看</router-link>
                                    </p>
                                </div>
                            </div>
                            
                            <!--新闻资讯/站内短信-->
                            <div class="tabbox">
                                <div class="tab">
                                    <p :class="{on:mouse == 1}" :style="{'color': varbgColor}" @mouseover="mouseover(1)" v-if="isShowNews">新闻资讯</p>
                                    <p :class="{on:mouse == 2}" :style="{'color': varbgColor}" @mouseover="mouseover(2)" v-if="isShowMessage">站内短信</p>
                                </div>
                                <div class="tabboxcontent">
                                    <ul style="width: 464px;">
                                        <li v-if="mouse == 1&&isShowNews">
                                            <span v-if="newsd&&newsd.length">
                                                <router-link :style="tmpTheme" :to="{path:'/news',query:{id:item.id}}" v-for="item in newsd" :key="item.id">{{item.title}}</router-link>
                                            </span>
                                            <div class="nothing" v-else>暂无数据</div>
                                        </li>
                                        <li v-if="mouse == 2&&isShowMessage">
                                            <p class="mess" :style="tmpTheme">您还没有登录，登录后查看</p>
                                        </li>
                                    </ul>
                                </div>
                                <router-link v-if="mouse == 1&&isShowNews" class="tabboxmore" :style="tmpTheme" :to="{path:'/news'}">更多</router-link>
                                <router-link v-if="mouse == 2&&isShowMessage" class="tabboxmore" :style="tmpTheme" :to="{path:'/station'}">更多</router-link>
                            </div>
                        </div>
                    </div>
                </div>
								<!-- 轮播广告 -->
								<div class="bannerAvatar" :style="{height:navTwoHeight+'px'}" v-if="isShowBannerAvatar=='2'">
									<div class="bannerAvatar_box">
										<div class="item" v-for="item in bannerAvatar" :key="item.id" @click="goBannerAvatar(item)">
											<div class="img_wrap">
												<div class="img"
													:style="{height:onavatarHeightType+'px'}"
													v-lazy:background-image="{
													src: item.img_Url,
													error: ''
												}"></div>
											</div>
										</div>
									</div>
								</div>
            </div>

						<!-- 广告模块 -->
						<div class="avatarList" v-if="avatarData.length&&showAvatar">
							<div class="box">
								<div class="list">
									<div class="item" v-for="(item,index) in avatarData" :key="index" @click="goAvatar(item)" v-if="item.isShow">
										<div class="img_wrap">
											<div class="img"
												:style="{height:avatarDataHeightType+'px'}"
												v-lazy:background-image="{
												src: item.img_Url,
												error: ''
											}"></div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<!-- 广告模块 -->

            <!--首页分类-->
            <div class="category_content" v-if="categoryShow">
                <ul class="indexs">
                    <li v-for="(item, index) in indexc" :key="index" :class="{addcolor: active===index,addcolor01:onactive == index}" @click="scrollTo(index)" :style="{'background': active===index?varbgColor:''}">{{item.name}}</li>
                    
                </ul>

                <div class="table_box table_box2" style="background: #F7F7F7;" v-if="isMallCategoryTitle">
                    <div class="all_category" style="background-color:#fff ;width: 1200px;margin: 0 auto;padding: 20px 0 15px 0;">
                        <p style="font-weight: 600;text-align:center;font-size: 26px;">商品分类</p>
                    </div>
                    
                </div>

                <product :base="base" @goParent="parentEvent"></product>
            
            </div>
            <Footer :base="base"></Footer>
            <slide></slide>
            <center></center>
        </template>
				<!-- 二维码 -->
        <el-dialog title="" width="450px" top="10%" :visible.sync="imgVisible">
            <div class="content_pop">
                <div class="img_wrap">
                    <img :src="imgdata?imgdata:''" alt="">
                    <div class="nothing" v-if="!imgdata">暂无图片</div>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="imgVisible = false">关闭</el-button>
            </div>
        </el-dialog>
			</div>
			<el-dialog
				title=""
				:visible.sync="ieTips"
				width="50%"
				center>
				<p style="margin-top:-20px"><img src="../assets/img/noIE.png" style="max-width:918px; width: 100%;"/></p>
				<div class="list_web">
					<!-- <a href="weixin:">打开微信</a> -->
					<div class="item" @click="goWeb(1)"><img src="../assets/img/1.png"/><p>安装包下载</p></div>
					<div class="item" @click="goWeb(2)"><img src="../assets/img/2.png"/><p>安装包下载</p></div>
					<div class="item" @click="goWeb(3)"><img src="../assets/img/3.png"/><p>安装包下载</p></div>
					<div class="item" @click="goWeb(4)"><img src="../assets/img/4.png"/><p>安装包下载</p></div>
				</div>
				<!-- <p>系统检测你的浏览器版本较低，建议你使用现代高版本浏览器<br><strong>(360极速版、谷歌、火狐、safari、Opera、Edge)</strong>等</p>
				
				<p>否则部分功能无法使用影响你的使用体验</p> -->
				<!-- <span slot="footer" class="dialog-footer">
					<el-button type="primary" @click="ieTips = false">知道了</el-button>
				</span> -->
			</el-dialog>
    </div>
</template>

<script>

import Header from '../components/Header.vue'
import Footer from '../components/Footer.vue'
import slide from '../components/homejs/slide.vue'
import product from '../components/homejs/product.vue'
import center from '../components/homejs/center.vue'
import $ from '../assets/js/jquery.min.js'
import { RouterLink } from 'vue-router'
export default{
    name:'Home',
    data() {
        return {
						hotPhone:'',
						hotPhoneIsShow:false,
						workTime:'',
						isShowWorkTime:false,
						showWindow:false,
            loginAfter:false,
            loginBefore:true,
            base: {},
            isShowManager: '',//是否显示业务员
            isShowCustomizedManager: '',//是否显示非标业务员
            username:'',
            user_name:'',
            userAvatar:'',
            chars:[],
            newsd:'',
            msgData:[],
            da:false,
            xiao:true,
            weid:true,
            yid:false,
            curIndex:0,
            classified:'',
            naviga:['首页','分类购买'],
            navindex:0,
            major:[],
            indexc:[],
            active:0,
            buyerInfo:{},
            onactive:0,
            mouse:1,
						imgVisible:false,
						imgdata:'',
						//浏览器
						ieTips:false,
						varbgColor: '',
						varfontColor: '',

						homeNavStyle:1, //2新样式 1老样式 导航和banner样式切换
						homeChartStyle:1, //轮播图

						//埋点时间
						startTime: null, // 记录开始加载页面的时间戳
      			endTime: null,   // 记录结束加载页面的时间戳
						//非标定制咨询图片
						customizedSeekImgSrc:'',//非标企业微信按钮
						customizedSeekQrCodeSrc:'',//非标企业微信二维码
						
						isShowBzQuery: 0,//是否开启启标准查询  1是 0否
						bzQueryUrl:'',//标准查询连接配置  如果有值才会显示【标准查询】

						openCustomized: 0,//是否开启非标定制品  1是 0否
						isShowPhone: 0,//控制是否显示手机号

						homeModelList:[],//右侧按钮集合

						isShowJobTime:'',//是否显示工作时间
						categoryShow:false,//商品分类开关
						isMallCategoryTitle:false,//商品分类标题开关

						showAvatar:false,//广告
						avatarData:'',
						avatarDataHeightType:'',

						isShowNews:false,//新闻
						isShowMessage:false,//短信
						navTwoHeight:'420',
						navTwoHeightIsAvatar:'420',
						isShowBannerAvatar:'1',//是否显示轮播广告
						onavatarHeightType:'',//轮播图 广告高度
            bannerAvatar:[],

						currentIndex:0

        }
    },
    components:{
        Header,
        Footer,
        slide,
        product,
        center,
        RouterLink
    },
    computed:{
        tmpTheme(){
            return {
                '--bgColor':this.$store.state.sysConfig.colorConfig?this.$store.state.sysConfig.colorConfig.bgColor:'#fff',
                '--fontColor':this.$store.state.sysConfig.colorConfig?this.$store.state.sysConfig.colorConfig.fontColor:'#fff'
            };
        }
    },
    created(){
			  //埋点时间
			  this.startTime = Date.now(); // 设置开始加载页面的时间戳为当前时间

				if(this.$store.state.browser.b == 'trident'){
					this.showWindow = false
					this.ieTips = true
				} else {
					this.showWindow = true
				}

        if(this.$route.path=='/home'){
            this.navindex=0
        }

        const _this = this;
        _this.loadconfig(true,function(data){
						_this.buyerInfo = JSON.parse(localStorage.getItem('buyerInfo') || '{}');
            // //配置信息
            _this.base=_this.$store.state.sysConfig.baseConfig;
						//是否显示工作时间 
            // _this.isShowJobTime=_this.$store.state.sysConfig.funcConfig.isShowJobTime;
						//是否显示业务员
            // _this.isShowManager=_this.$store.state.sysConfig.funcConfig.isShowManager;
						//是否显示非标业务员
            // _this.isShowCustomizedManager=_this.$store.state.sysConfig.funcConfig.isShowCustomizedManager;
					  //非标定制咨询图片
            // _this.customizedSeekImgSrc=_this.$store.state.sysConfig.funcConfig.customizedSeekImgSrc;
            // _this.customizedSeekQrCodeSrc=_this.$store.state.sysConfig.funcConfig.customizedSeekQrCodeSrc;

						_this.openCustomized=_this.$store.state.sysConfig.funcConfig.openCustomized; //是否开启非标定制品  1是 0否

						_this.isShowBzQuery=_this.$store.state.sysConfig.funcConfig.isShowBzQuery; //是否开启标准查询  1是 0否
            _this.bzQueryUrl=_this.$store.state.sysConfig.funcConfig.bzQueryUrl;//标准查询 链接

            _this.isShowPhone=_this.$store.state.sysConfig.funcConfig.isShowPhone;//控制是否显示手机号
						_this.varbgColor = _this.$store.state.theme.bgColor
						_this.varfontColor = _this.$store.state.theme.fontColor
						_this.homeNavStyle=_this.$store.state.sysConfig.funcConfig.homeNavStyle; //2新样式 1老样式
						// _this.homeChartStyle=_this.$store.state.sysConfig.funcConfig.homeChartStyle; //轮播图 1高度420样式 2高度620样式
						
						// _this.homeModelList=_this.$store.state.sysConfig.funcConfig.homeModelList; //右侧按钮集合
						// _this.isMallCategoryTitle=_this.$store.state.sysConfig.funcConfig.isMallCategoryTitle; //商品分类开关

						
						_this.getConfigData()

        })

        this.$nextTick(() => {

            if(localStorage.getItem('token')!=null){
                this.loginBefore=false
                this.loginAfter=true
                this.yid=true
                this.weid=false
                this.username=localStorage.getItem('username')
								this.getCurrentUserInfo()
            }else{
                this.loginBefore=true
                this.loginAfter=false
                this.yid=false
                this.weid=true
            }
            // if(localStorage.getItem('buyerInfo')){
            //     this.user_name=JSON.parse(localStorage.getItem('buyerInfo')).buyerName;
            // }
            

            this.$api.chartlist({
                SourceType:'1'
            }).then(res=>{
                this.chars=res.data
                for(var i=0;i<this.chars.length;i++){
                    this.chars[i].img_Url=localStorage.getItem('lunbo')+this.chars[i].img_Url
                }
								
                if(this.chars.length==2){
                    this.da=false
                    this.xiao=true
                }else{
                    this.da=true
                    this.xiao=false
                }
            })
            this.$api.newslist({
                "SourceType": 1,
            }).then(res=>{
                this.newsd=res.data
            })
            this.$api.getMessageList({
							isRead:-1
						}).then(res=>{
                if(res.data.status){
									this.msgData = res.data.data.pageData
                }
                
            })
            this.$api.classify().then(res=>{
                this.classified=res.data.data
            })

            
        })


        // 调用
        // let params = 'id=90&com=rrrr'
        // this.ajaxPost('http://139.159.221.172:8098/Socket/WeChatInterface.asmx/GetWaterUsedRptForDay', params, function (data) {
        //     // 后台返回的数据就是 字符串类型。要转成json，必须自己手动转换。
        //     var user = JSON.parse(data);
        //     console.log(user.id);
        //     console.log(user.com);
        // });

				
    },
    mounted(){

        // $(function(){
        //     // 新闻资讯
        // $('.tabbox .tabboxcontent ul').width(232*$('.tabbox .tabboxcontent li').length+'px');
        // $(".tabbox .tab p").mouseover(function(){
        //     $(this).addClass('on').siblings().removeClass('on');

        //     $(".tabboxmore").attr("href", $(this).attr("href"));
        //     var index = $(this).index();
        //     var number;
        //     number = index;
        //     var distance = -232*index;
        //     $('.tabbox .tabboxcontent ul').stop().animate({
        //         left:distance
        //     });
        // });
        
        // })
        window.addEventListener('scroll', this.handleScroll)
        
    },
    beforeUpdate(){
        document.title = this.base.webTitle
        let key=document.querySelector("meta[name*='keywords']"||document.createElement('meta'))
        let descri=document.querySelector("meta[name*='description']"||document.createElement('meta'))
        key.content=this.base.webKeyword
        descri.content=this.base.webDescription
        key.name='keywords'
        descri.name='description'
    },
    destroyed(){
			window.removeEventListener('scroll', this.handleScroll)
    },
    methods:{
			
			//获取配置
			getConfigData(){
				const _this = this;
				let params={
					templateType:'homeTemplatePc', //模板类型：homeTemplatePc电脑端，homeTemplateMob手机端
				};
				this.$api.GetHomeTemplate(params).then(res=>{
					
					if(res.data.status){
						let fetch = res.data.data;
						if(fetch){
							//工作电话
							_this.hotPhoneIsShow = fetch.topheaderData.hotPhoneIsShow;
							_this.hotPhone = fetch.topheaderData.hotPhone;
							//工作时间
							_this.isShowWorkTime = fetch.bannerPartData.isShowWorkTime;
							_this.workTime = fetch.bannerPartData.workTime;

							//轮播图广告
							_this.isShowBannerAvatar = fetch.bannerPartData.isShowBannerAvatar;
							//轮播图高度
							_this.navTwoHeight = _this.isShowBannerAvatar=='2'?fetch.bannerPartData.avatarHeightType:fetch.bannerPartData.heightType;
							
							_this.navTwoHeightIsAvatar = _this.isShowBannerAvatar=='2'?(fetch.bannerPartData.banneravatarHeightType):fetch.bannerPartData.heightType;

							_this.bannerAvatar = fetch.bannerPartData.bannerAvatar;

							_this.onavatarHeightType = fetch.bannerPartData.onavatarHeightType;

							//快捷入口
							let navigaList = fetch.bannerPartData.naviga;
							if(navigaList.length){
								_this.homeModelList = navigaList;
							}
							//新闻
							_this.isShowNews = fetch.bannerPartData.isShowNews;
							_this.isShowMessage = fetch.bannerPartData.isShowMessage;
							if(_this.isShowNews||(_this.isShowNews&&_this.isShowMessage)){
								_this.mouse=1
							}else if(!_this.isShowNews||_this.isShowMessage){
								_this.mouse=2
							}
							//非标定制咨询
							_this.isShowCustomizedManager = fetch.bannerPartData.isShowCustomizedManager;
							_this.customizedSeekImgSrc = fetch.bannerPartData.dialogImageUrl;
							_this.customizedSeekQrCodeSrc = fetch.bannerPartData.QRdialogImageUrl;
							//是否显示专属客服/专属业务经理
							_this.isShowManager = fetch.bannerPartData.isShowManager;
							//广告
							_this.showAvatar = fetch.avatarData.isShow;
							_this.avatarData = fetch.avatarData.avatarList;
							_this.avatarDataHeightType = fetch.avatarData.heightType;
							//首页分类
							_this.categoryShow = fetch.indexCategoryData.categoryShow;
							_this.isMallCategoryTitle = fetch.indexCategoryData.isShowTitle;
						} 
					} else {
						this.$message.error(res.message)
					}
				});
			},
			foList(type){
				// console.log(this.homeModelList)
				if(this.homeModelList.length){
					let f_isshow = this.homeModelList.find(item=>item.code==type)
				  return f_isshow.isShow
				} else {
					return []
				}
				
			},
			//轮播广告
			goBannerAvatar(item){
				if(item.link_Href){
					window.open(item.link_Href,'_blank')
				}
			},
			goAvatar(item){
				if(item.link_Href){
					window.open(item.link_Href,'_blank')
				}
			},
			//获取用户信息
			getCurrentUserInfo(){
					this.$api.getCurrentUserInfo({
							password: this.password,
							userName: this.username
					}).then(res=>{
						  if(res.data.status){
								  this.user_name = res.data.data.fullName;
									this.userAvatar = res.data.data.headImageUrl;
							}else{
									this.$message.error(res.data.message);
							}
					})
			},
			goWeb(type){
				let url = ''
				let name = ''
				if(type == 1){
					url = 'https://dsm.szqgj.com/360se14.1.1116.0.exe'
					name = '360'
				} else if(type == 2){
					url = 'https://dsm.szqgj.com/Firefox_114.0.2.8570.exe'
					name = '火狐'
				} else if(type == 3){
					url = 'https://dsm.szqgj.com/GoogleChrome_114.0.5735.199.exe'
					name = '谷歌'
				} else if(type == 4){
					url = 'https://dsm.szqgj.com/360_13.5.2042.0.exe'
					name = '360极速'
				} 
				// console.log(url);
				let link = document.createElement("a"); 
				//创建一个a标签
				link.style.display = "none"; 
				//将a标签隐藏
				link.href = url; 
				//给a标签添加下载链接  "域名+接口"  safe是一个动态的域名  后面的接口替换成你自己的下载接口
				link.setAttribute("download", name); 
				// 此处注意，要给a标签添加一个download属性，属性值就是文件名称 否则下载出来的文件是没有属性的，空白白
				document.body.appendChild(link);
				//将上面创建的a标签加入到body的尾部
				link.click();
			},
				//客服图
				showimg(data){
						this.imgdata = data;
						this.imgVisible = true
				},
        mouseover(e){
            this.mouse = e;
        },
        getLogin(data){
            this.loginBefore = !data
            this.loginAfter = data
        },
        parentEvent(msg) {
            //msg接收子组件传来的值
            this.indexc = msg;
        },
        handleScroll () {
            const scrollTop = document.documentElement.scrollTop|| document.body.scrollTop
            var offsetTop = document.querySelector('.categroy_centers').offsetTop
            var indexs = document.querySelector('.indexs')
						var headerBox = document.querySelector('.headerBox')
						if (scrollTop>620 ) {
							headerBox.classList.add('headerBoxFiexd')
            } 
						if (scrollTop<510 ) {
							headerBox.classList.remove('headerBoxFiexd')
            }
            let sectionLi = document.querySelectorAll('.categroy_centers .categroy_center2')
            let indexsLi = document.querySelectorAll('.indexs li')
            if (offsetTop-scrollTop<=120 ) {
                indexs.style.display='block'
            } else if(offsetTop-scrollTop>120){
                indexs.style.display='none'
            }
            // 获取所有锚点元素
            const navContents = document.querySelectorAll('.categroy_centers>.categroy_center2')
            // 所有锚点元素的 offsetTop
            const offsetTopArr = []
            navContents.forEach(item => {
            offsetTopArr.push(item.offsetTop)
            })
            //   获取当前文档流的 scrollTop
            //   const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
            // 定义当前点亮的导航下标
            let navIndex = 0
            for (let n = 0; n < offsetTopArr.length; n++) {
            // 如果 scrollTop 大于等于第n个元素的 offsetTop 则说明 n-1 的内容已经完全不可见
            // 那么此时导航索引就应该是n了
            
            if (offsetTopArr[n]-scrollTop<=40 ) {
                navIndex = n
            }
            }
            this.active = navIndex
            this.onactive = navIndex
        },
        cart(){
            this.$router.push('/cart')
        },
        // 跳转到指定索引的元素
        scrollTo(index) {
            // 获取目标的 offsetTop
            // css选择器是从 1 开始计数，我们是从 0 开始，所以要 +1
            const targetOffsetTop = document.querySelector(`.categroy_centers>div:nth-child(${index + 1})`).offsetTop
            // 获取当前 offsetTop
            let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
            // 定义一次跳 50 个像素，数字越大跳得越快，但是会有掉帧得感觉，步子迈大了会扯到蛋
            const STEP = 5000
            // 判断是往下滑还是往上滑
            if (scrollTop > targetOffsetTop) {
                // 往上滑
                smoothUp()
            } else {
                // 往下滑
                smoothDown()
            }
            this.onactive = index
            this.active = index
            // 定义往下滑函数
            function smoothDown() {
                // 如果当前 scrollTop 小于 targetOffsetTop 说明视口还没滑到指定位置
                if (scrollTop < targetOffsetTop) {
                // 如果和目标相差距离大于等于 STEP 就跳 STEP
                // 否则直接跳到目标点，目标是为了防止跳过了。
                if (targetOffsetTop - scrollTop >= STEP) {
                    scrollTop += STEP
                } else {
                    scrollTop = targetOffsetTop
                }
                document.body.scrollTop = scrollTop
                document.documentElement.scrollTop = scrollTop
                // 关于 requestAnimationFrame 可以自己查一下，在这种场景下，相比 setInterval 性价比更高
                requestAnimationFrame(smoothDown)
                }
            }
            // 定义往上滑函数
            function smoothUp() {
                if (scrollTop > targetOffsetTop) {
                if (scrollTop - targetOffsetTop >= STEP) {
                    scrollTop -= STEP
                } else {
                    scrollTop = targetOffsetTop
                }
                document.body.scrollTop = scrollTop
                document.documentElement.scrollTop = scrollTop
                requestAnimationFrame(smoothUp)
                }
            }
            
        },

        
        prev(){
            this.$refs.swiper.prev()
        },
        next(){
            this.$refs.swiper.next()
        },
        tui(){
            localStorage.clear();
            this.$router.push('/login')
        },
        jump(item){
            if(item.link_Href!=null){
                // window.location.href='http://'+item.link_Href
                window.location.href = item.link_Href
            }
        },
        cates(){
            this.$router.push('/category')
        },

				changeCarousel(e) {
					this.currentIndex = e
				},
				changeIndicator(index){
					console.log(this.$refs.carouselTax)
					this.$refs.carouselTax.setActiveItem(index)
					this.currentIndex = index
				},

        handleCarousel(index){
            this.$refs.carouselTax.setActiveItem(index)
        },
        qie(index){
            if(index==0){
                this.navindex=0
                this.$router.push('/')
            }else{
                this.navindex=1
                this.$router.push('/category')
            }
        },
        getCur(a, b) {
            var xian=document.querySelector('.navtab:nth-child(2)')
            var yin=document.querySelector('.navtab:nth-child(3)')
            if (a == 0) {
                this.curIndex = 0;
                xian.style.display='block'
                yin.style.display='none'
            } else if (a == 1) {
                this.curIndex = 1;
                yin.style.display='block'
                xian.style.display='none'
            } else {
                this.curIndex = 2;
            }
        },
        xiaolei(item,item1,items){
            this.$router.push({path:'/catlist',query:{idd:item.id,cz:item1.name,smalls:items.id}})
        },
        siji(item,item3,item4){
            this.$router.push({path:'/catlist',query:{idd:item.id,cz:item3.name,smalls:item4.id}})
        },
				goPath(item){
					if(item.code=='order'){
						this.$router.push({path:'/order'})
					}else if(item.code=='quick'){
						this.$router.push({path:'/quickOrder',query:{tab:3}})
					}else if(item.code=='bz'){
						window.open(this.bzQueryUrl,'_blank')
					}else if(item.code=='customized'){
						this.$router.push({path:'/customNonStandard'})
					}else if(item.code=='cart'){
						this.$router.push({path:'/cart'})
					}else if(item.code=='returnorder'){
						this.$router.push({path:'/record'})
					}else if(item.code=='saleaccount'){
						this.$router.push({path:'/account'})
					}else if(item.code=='complaint'){
						this.$router.push({path:'/Complaint'})
					}
				},
    },
		beforeDestroy() {
			
		},
		beforeRouteLeave(to, from, next){
			//行为埋点
			const _this = this;
			this.endTime = Date.now();
			const stayDuration = (this.endTime - this.startTime) / 1000; // 计算停留时间（单位：秒）
			//行为埋点
			this.setBehaviorPoint({
				ViewPath: _this.$route.path,
				ViewName: '首页',
				Timer: stayDuration,
				// BrowserType: '',
			});
			next();
		}
}
    
</script>
<style>
.home #nav .nav_box .nav_two{
    display: block!important;
}
.el-dialog--center .el-dialog__body {
	padding-top: 0!important;
	padding-bottom: 40px!important;
}
.el-dialog__headerbtn {
	font-size: 24px!important;
	top: 10px!important;
	right: 10px!important;
}
</style>
<style scoped lang="scss">
// @import url('../assets/style/home.css');
@import url('../assets/style/index.css');
.current{
    border: 1px solid transparent !important;
    background: #e50015 !important;
    color: #fff !important;
    border-radius: 4px;
}
.block{
    width: 100%;
    height: 423px;
    position: absolute;
}
.banner_item {
	display: inline-block;
	width: 100%;
	height: 423px;
	background-color: #f7f7f7;
	position: relative;
	.item_b {
		background-position: center;
		background-repeat: no-repeat;
		background-size: cover;
		width: 760px;
		height: 423px;
		position: absolute;
    top: 0;
    left: 50%;
    margin-left: -411px;
	}
}
:deep .el-carousel,:deep .el-carousel__container{
    height: 100%;
}

:deep .el-carousel__item{
    height: 100%;
}
.el-carousel__item img {
    width: 100%;
    height: 100%;
    margin: 0;
    cursor: pointer;
  }

  
  :deep .el-carousel__button {
//   border: 1px solid gray;
  width: 10px;
  height: 10px;
  border-radius: 50%;
}
:deep .el-carousel__arrow{
    // display: none;
}
:deep .el-carousel__arrow--right {
  margin-right: -332px;
	right: 50% !important;
	display: none!important;
}
:deep .el-carousel__arrow--left {
  margin-left: -395px;
	left: 50% !important;
	display: none!important;
}



// 指示器
.custom-indicator {
  display: flex;
  justify-content: center;
  margin-top: 10px;
	position: absolute;
	z-index: 9;
	left: 50%;
	margin-left: -60px;
	bottom: 10px;
}
.el-carousel__item h3 {
  color: #475669;
  opacity: 0.75;
  line-height: 150px;
  margin: 0;
  text-align: center;
}
.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}
.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
.custom-indicator div {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: rgb(184, 184, 184);
  margin: 0 5px;
  cursor: pointer;
}
.custom-indicator div.active {
  background-color: #fff;
}



.el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 150px;
    margin: 0;
  }

  .el-carousel__item:nth-child(2n) {
     background-color: #99a9bf;
  }
  
  .el-carousel__item:nth-child(2n+1) {
     background-color: #d3dce6;
  }

	// banner广告 开始
	.bannerAvatar {
		width: 1200px;
		margin: 0 auto;
		position: relative;
		.bannerAvatar_box {
			width: 760px;
			display: flex;
			position: absolute;
			bottom: 0;
			left: 50%;
			margin-left: -411px;
			z-index: 9;
			padding-left: 10px;
			.item {
				width: 100%;
				margin-right: 10px;
				cursor: pointer;
				.img_wrap {
					width: 100%;
					.img {
						height: 120px;
						background-size: cover;
						background-repeat: no-repeat;
						background-position: center;
					}
				}
			}
		}
	}
	// banner广告 结束


  .navtab:nth-child(3){
    display: none;
  }
  #nav .nav_box .nav_two .nav_two_span .nav_three_box .nt_row_right .nt_row_right_li:hover>.nt_show{
    display: block;
  }
  .actives{
    color: #e60012 !important;
}
.home #nav .nav_box .nav_two{
    display: block;
}
.Member_info {
	border-bottom: unset
}
.Member_info ul li a{
    color: var(--bgColor);
}
.Member_info ul li{
    border-color: var(--bgColor);
}
.Member_info ul li:hover{
    background: #eaebec;
}
.Member_info ul li:hover a{
    color: #fff;
}
.zhuan> span,.shang > span{
    background:var(--bgColor);
    border-color: var(--bgColor);
    color: var(--fontColor);
}
.xia>p>a,
.xia p {
    color: var(--bgColor);
}
.tabbox .tab p.on{
    border-bottom-color: #666;
    color: #666;
}
.tabbox .tabboxcontent li a:hover,
.news_box .Member_info .outloginBtn{
    color: var(--bgColor);
}

.indexs li.addcolor{
    background: var(--bgColor);
    color: var(--fontColor);
}
// .indexs li.addcolor{
//     background: unset;
//     color: unset;
// }
.indexs li.addcolor01{
    background: var(--bgColor, red);
    color: var(--fontColor,#fff);
}
.category_content {
    // max-width: 1200px;
    // margin: 0 auto;
    // position: relative;
}
// .indexs {
//     width: 50px;
//     background-color: #000000;
//     color: #ffffff;
//     position: fixed;
//     left: 50%;
//     top: 110px;
//     margin-left: -41%;
//     display: none;
// }
.exclusive {
	.contact_list {
		width: 100%;
    display: flex;
    align-items: center;
		background: var(--bgColor,red);
		position: relative;
		overflow: hidden;
		.iconfont {
			position: absolute;
			top: 9px;
			left: -7px;
			font-size: 36px;
			color: #fff;
			opacity: 0.2;
		}
		.item {
			flex: 1;
			display: inline-block;
			padding: 4px 0;
			text-align: center;
			font-weight: 550;
			font-size: 14px;
			border-color: unset;
			color: var(--fontColor,#fff);
		}
		.item:nth-child(2){
			// margin-left: 3px;
			position: relative;
		}
		.item:nth-child(2):after{
			content:'';
			position: absolute;
			top:7px;
			left: 0;
			width: 1px;
			height: 14px;
			background-color: #fff;
		}
	}
}

.xia>p{
    flex: 1;
    text-align: center;
    padding: 66px 0;
    border-bottom: 0.5px solid #ebebeb;
}
.xia>p>a{
    color: #e60012;
}
.manager p {
    font-size: 12px;
    text-align: center;
    font-weight: 600;
}
.manager > p:nth-child(2) {
    font-size: 12px;
}
.xia {
	display: flex;
	.manager {
		flex: 1;
		padding: 6px 0 0 0;
		.name {
			color: #333
		}
	}
}
.xia .manager .img {
    width: 70px;
    height: 70px;
    margin: 0 auto;
    cursor: pointer;
}
.xia .manager .img img {
    width: 70px;
    height: 70px;
}
.content_pop {
	overflow: hidden;
    .img_wrap {
        width: 350px;
        height: 350px;
        margin: 0 auto;
        img {
            width: 100%;
        }
    }
}
.nothing {
    padding: 20px 0;
}
.list_web {
	display: flex;
	.item {
		flex: 1;
		text-align: center;
		cursor: pointer;
		img {
			width: 100px;
		}
	}
}
.newStyle {
	.main-center,.block,.banner_item,.new,.news_box,.item_b{
		height: 620px;
	}
	.banner_item {
		.item_b {
			top: 0;
		}
	}
	// .Member_info {
	// 	height: 120px;
	// }
	// .Member_info p {
	// 	height: 22px;
	// 	margin-bottom: 8px;
	// }
	.xia > .manager {
		padding-top: 10px;
	}
	.tabbox .tabboxcontent {
		height: 230px;
	}
	.tabbox {
		padding-top: 10px;
	}
	.tabbox .tabboxcontent ul {
		height: 230px;
	}
	.tabbox .tabboxcontent li {
		height: 230px;
	}
	.tabbox .tabboxcontent li a {
		padding: 6px 0;
	}
	.nothing {
		padding: 60px 0;
	}
}
.feibiao {
	.manager {
		text-align: center;
		position: relative;
		padding:0;
		margin-bottom:5px;
		cursor: pointer;
		.img {
			width: 251px;
			height: 40px;
			img {
				width: 251px;
			  height: 40px;
			}
		}
		i {
			font-size: 50px;
		}
		.line {
			color: var(--bgColor,red);
		}
		.wx {
			color: #2ae246
		}
		.text {
			font-size: 13px;
			font-weight: 600;
			margin-top: 5px;
		}
	}
	.manager::after {
		content: '';
		width: 1px;
		height: 50px;
		background-color: #e8e8e8;
		position: absolute;
		top: 22px;
		right: 0;
	}
	.manager:last-child::after{
		content: unset;
	}
	.xia > p {
		padding: 35px 0;
	}
}
.fool_list {
	display: flex;
	align-items: center;
	border-bottom: 1px solid #ebebeb;
	padding-bottom: 8px;
	.fool_item {
		flex:1;
		text-align: center;
		cursor: pointer;
		.iconfont {
			font-size: 35px;
			color: var(--bgColor,red)
		}
		.text {
			font-size: 12px;
		}
	}
}
.phtime {
	text-align: left;
	padding: 5px 0;
	padding-left: 15px;
	color: #666;
	.phone {
		font-size: 12px;
		.iconfont {
			color: var(--bgColor,red)
		}
		span {
			font-size: 14px;
			// font-weight: bold;
		}
	}
	.text {
		font-size: 12px;
	}
}
.avatarList {
	.box {
		width: 1200px;
		margin: 0 auto;
		background-color: #fff;
		padding: 20px 0;
	}
	.list {
		margin-right: -10px;
		display: flex;
		.item {
			// width: calc(20% - 10px);
			width: 100%;
			margin-right: 10px;
			display: inline-block;
			cursor: pointer;
			.img_wrap {
				.img {
					// padding-top: 94%;
					height: 220px;
					background-size: cover;
					background-position: center;
					background-repeat: no-repeat;
				}
			}
		}
	}
}
</style>